import { Switch, Route, BrowserRouter, Redirect, useLocation } from "react-router-dom";

import Accueil from "../../Pages/Scene/DynamicScene";
import NotFound from "../../Pages/NotFound/NotFound";
import Navbar from "../../Components/Navbar/Navbar";

function Nav({ component }: { component: any }) {  // This function is used to display the navbar only in the correct pages 
    const { pathname } = useLocation();
    const MyComponent = component;

    if (pathname !== "/")
        return null;
    return <MyComponent />;
}

export default function Router() {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={Accueil} />
                <Route path="/404" component={NotFound} />
                <Redirect to="/404" />
            </Switch>
            {/* <Nav component={Navbar} /> */}
        </BrowserRouter>
    )
}